var VoiceMessageBuilder = /** @class */ (function () {
    function VoiceMessageBuilder() {
        this.voiceMessage = {
            mode: 'tts',
            textToSpeech: {
                text: 'default English text2speech message',
                locale: 'en',
            },
            audioFile: {
                url: '',
                name: ''
            }
        };
    }
    VoiceMessageBuilder.prototype.withMode = function (mode) {
        this.voiceMessage.mode = mode;
        return this;
    };
    VoiceMessageBuilder.prototype.withTextToSpeech = function (textToSpeech) {
        this.voiceMessage.textToSpeech = textToSpeech;
        return this;
    };
    VoiceMessageBuilder.prototype.withAudioFile = function (audioFile) {
        this.voiceMessage.audioFile = audioFile;
        return this;
    };
    VoiceMessageBuilder.prototype.build = function () {
        return this.voiceMessage;
    };
    return VoiceMessageBuilder;
}());
export { VoiceMessageBuilder };
//# sourceMappingURL=voice-message.builder.js.map